import { Route, NavigationGuardNext } from 'vue-router';
import { redirect } from '@/helpers/redirects';
import store from '../../store';

export const requireProvider = (_to: Route, _from: Route, next: NavigationGuardNext) => {
  if (store.getters['account/getAccount']?.isSitter()) {
    next();
  } else {
    redirect('/login');
  }
};

export const requireSeeker = (_to: Route, _from: Route, next: NavigationGuardNext) => {
  if (store.getters['account/getAccount']?.isParent()) {
    next();
  } else {
    redirect('/login');
  }
};

export const requirePremium = (_to: Route, _from: Route, next: NavigationGuardNext) => {
  if (store.getters['account/getAccount']?.isPremium()) {
    next();
  } else {
    redirect('/login');
  }
};
